import { Component, OnInit, Input } from '@angular/core';
import { StageService } from '../../services/stage-modal.service';
import { ModeEffectif, Option, RenderType } from '../../../../../models/effectif/option.model';
import { CoreService, HttpService } from '../../../../../services';
import { CRUD, QResult, Recipient, RecipientModel, Select } from '../../../../../models';
import { ExtraGestionAcces } from '../../../../../models/formation/formation.model';
import { ToastService } from '../../../../../toast';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GenericEffectif } from '../../../../../models/effectif/genericEffectif.model';
import { Dictionary } from 'lodash';

@Component({
  selector: 'queoval-stage-portail-extranet',
  templateUrl: './portail-extranet.component.html',
  styleUrls: ['./portail-extranet.component.css']
})

export class PortailExtranetComponent implements OnInit {

  constructor(
    public service: StageService,
    private http: HttpService,
    public indParam: CoreService,
    private toast: ToastService,
    private modalService: NgbModal
  ) { }

  public dicRecipientList: Dictionary<Recipient[]> = {};

  public OptionStagiaire: Option;
  public OptionFormateur: Option;
  public OptionResponsables: Option;


  public ngOnInit(): void {

    this.OptionStagiaire = new Option(this.service.Stage.Ident, this.service.Stage.Ident, ModeEffectif.STAGIAIREMAIL);
    this.OptionFormateur = new Option(this.service.Stage.Ident, this.service.Stage.Ident, ModeEffectif.FORMATEURMAIL);
    this.OptionResponsables = new Option(this.service.Stage.Ident, this.service.Stage.Ident, ModeEffectif.ALLCONTACTRH);

    this.dicRecipientList['APPRENANT'] = new Array<Recipient>();
    this.dicRecipientList['FORMATEUR'] = new Array<Recipient>();
    this.dicRecipientList['RESPONSABLERH'] = new Array<Recipient>();

  }


  public deleteAcces() {
    this.gestionAccesExtranet(true);
  }

  public createAcces() {
    this.gestionAccesExtranet(false);
  }

  private gestionAccesExtranet(isDelete: boolean) {
    const gestionAcces: ExtraGestionAcces = new ExtraGestionAcces();
    gestionAcces.Action = isDelete ? CRUD.DELETE : CRUD.CREATE;
    gestionAcces.NiveauRole = "";

    gestionAcces.LstIdentApprenant = new Array<string>();
    this.dicRecipientList['APPRENANT'].forEach(cnt => {
      if (cnt.Ident) {
        gestionAcces.LstIdentApprenant.push(cnt.Ident);
      }
    })

    gestionAcces.LstIdentFormateur = new Array<string>();
    this.dicRecipientList['FORMATEUR'].forEach(cnt => {
      if (cnt.Ident) {
        gestionAcces.LstIdentFormateur.push(cnt.Ident);
      }
    })

    gestionAcces.LstIdentResponsableRH = new Array<string>();
    this.dicRecipientList['RESPONSABLERH'].forEach(cnt => {
      if (cnt.Ident) {
        gestionAcces.LstIdentResponsableRH.push(cnt.Ident);
      }
    })


    this.http.postHttp<QResult<ExtraGestionAcces>>(`${this.indParam.AppParams.apiUrl}api/Stage/Extranet/GestionAcces/MANAGEACCES`, gestionAcces).subscribe(
      (result: QResult<ExtraGestionAcces>) => {
        if (!result.HasError) {
          this.toast.showSuccessToast(isDelete ? "Suppression des accès extranet effectuée" : "Création des accès extranet effectuée");
          this.ReloadEffectifComponent();
        }
      });

  }

  public sendEmailAccesExtranet() {
    const gestionAcces: ExtraGestionAcces = new ExtraGestionAcces();
    gestionAcces.Action = CRUD.READ;
    gestionAcces.NiveauRole = "";

    gestionAcces.LstIdentApprenant = new Array<string>();
    this.dicRecipientList['APPRENANT'].forEach(cnt => {
      if (cnt.Ident) {
        gestionAcces.LstIdentApprenant.push(cnt.Ident);
      }
    })

    gestionAcces.LstIdentFormateur = new Array<string>();
    this.dicRecipientList['FORMATEUR'].forEach(cnt => {
      if (cnt.Ident) {
        gestionAcces.LstIdentFormateur.push(cnt.Ident);
      }
    })

    gestionAcces.LstIdentResponsableRH = new Array<string>();
    this.dicRecipientList['RESPONSABLERH'].forEach(cnt => {
      if (cnt.Ident) {
        gestionAcces.LstIdentResponsableRH.push(cnt.Ident);
      }
    })

    this.http.postHttp<QResult<ExtraGestionAcces>>(`${this.indParam.AppParams.apiUrl}api/Stage/Extranet/GestionAcces/SENDEMAILACCES`, gestionAcces).subscribe(
      (result: QResult<ExtraGestionAcces>) => {
        if (!result.HasError) {
          this.toast.showSuccessToast("Emails envoyés aux contacts ayant une adresse mail");
          this.ReloadEffectifComponent();
        }
      });

  }

  public isDisabled(): boolean {
    const isDisabled: boolean = this.dicRecipientList['APPRENANT'].length === 0 && this.dicRecipientList['FORMATEUR'].length === 0 && this.dicRecipientList['RESPONSABLERH'].length === 0;
    return isDisabled;
  }

  public updateListPersonne(effectifData: Array<GenericEffectif>, typeData: string) {

    //cas ou on séléctionne l'effectif
    if (effectifData.length > 0) {

      effectifData.forEach(Effectif => {
        if (Effectif.IsSelected) {
          //verifie si l'effectif existe dans la liste
          let EffecExistInList: boolean = false;
          for (var i = 0; i < this.dicRecipientList[typeData].length; i++) {
            if (this.dicRecipientList[typeData][i].Ident == Effectif.Id) {
              EffecExistInList = true;
              break;
            }
          }
          //si l'effectif n'existe pas dans la liste on l'ajoute
          if (!EffecExistInList) {
            const newRecipient: Recipient = new Recipient();
            newRecipient.Ident = Effectif.Id;
            newRecipient.TypeRecipient = 'CONTACT';
            this.dicRecipientList[typeData].push(newRecipient);
          }

        } else {
          // Si l'effectif existe dans la liste ou le retire
          this.dicRecipientList[typeData].forEach(recip => {
            if (Effectif.Id == recip.Ident && !Effectif.IsSelected) {
              this.dicRecipientList[typeData].splice(this.dicRecipientList[typeData].indexOf(recip), 1);
            }
          })
        }
      });
    }
  }

  public getListSelected(typeData: string): Array<string> {
    let liste: Array<string> = [];
    this.dicRecipientList[typeData].forEach(r => { liste.push(r.Ident) });
    return liste;
  }

  /*
   * Pour l'ouverture d'une modal
   */
  open(Modal: any) {
    this.modalService.open(Modal, { centered: true, windowClass: 'qmodalover' });
  }

  /**
   * recharge les composant effectifs à la fin de chaque action
   * */
  private ReloadEffectifComponent(): void {
    // RAZ des effectifs selectionnés
    this.dicRecipientList['APPRENANT'] = new Array<Recipient>();
    this.dicRecipientList['FORMATEUR'] = new Array<Recipient>();
    this.dicRecipientList['RESPONSABLERH'] = new Array<Recipient>();
    // MAJ des infos des effectifs
    this.service.RefreshEffectif = true;
    setTimeout(() => { this.service.RefreshEffectif = false }, 1);
  }

}
